import data from './pcdf_mobile.json';

export interface PcdbData {
  id: string;
  type: string;
  mfcRefNo: string;
  brandName: string;
  modelName: string;
  modelQualifier: string;
  boilerId: string;
  mfcFinalYear: string;
  flueType: string;
  fanAssistance: string;
  field1: string;
  field2: string;
}

export interface PcdbResponse {
  data: {
    pcdf: PcdbData[];
  };
}

export const rdsapPCDBData = data as PcdbResponse;
